import {FC} from 'react'
import {brandName} from '../../../../_metronic/helpers'
import {TermsViewerButton} from '../../terms'

/**
 * «حساب کاربری شخصی و مسئولیت استفاده از آن» (user decision 2026-10-29): what a personal account means and who answers
 * for shared use, and the acknowledgment every request of «تکمیل حساب کاربری» and of the sign-in link carries
 * (acceptPersonalUse; the server refuses without it, 400 PERSONAL_USE_REQUIRED).
 */
export const PersonalUseNotice: FC<{
  accepted: boolean
  onChange: (value: boolean) => void
  disabled?: boolean
}> = ({accepted, onChange, disabled}) => (
  <section className='account-entry__notice' aria-labelledby='personal-use-title'>
    <h2 id='personal-use-title'>
      <i className='las la-user-shield' aria-hidden='true' /> حساب کاربری شخصی و مسئولیت استفاده از
      آن
    </h2>
    <p>
      هر حساب کاربری در {brandName} فقط به یک شخص حقیقی تعلق دارد و با شماره موبایل تأییدشده‌ی همان
      شخص شناخته می‌شود. همه‌ی کارهایی که با یک حساب انجام می‌شود، از صدور، ویرایش، ارسال و ابطال
      صورتحساب تا تغییر تنظیمات و دسترسی‌ها، به نام صاحب همان حساب ثبت می‌شود و در گزارش‌ها قابل
      پیگیری است.
    </p>
    <p>
      در اختیار دیگران گذاشتن نام کاربری، رمز عبور، کد یک‌بارمصرف یا لینک ورود، و استفاده‌ی چند نفر
      از یک حساب ممنوع است. مسئولیت همه‌ی پیامدهای چنین استفاده‌ای، از جمله صورتحساب‌هایی که به
      سامانه‌ی مؤدیان فرستاده می‌شود و تعهدات مالیاتی، حقوقی و مالی ناشی از آن، به‌طور کامل بر
      عهده‌ی کسب‌وکار و صاحب حساب است.
    </p>
    <p>
      برای هر همکار، مدیر کسب‌وکار باید در «کاربران و دسترسی‌ها» کاربر جداگانه با شماره موبایل خود
      او تعریف کند. نام کاربری و رمز عبور شخصی برای روزهایی است که پیامک نمی‌رسد.
    </p>
    <label className='account-entry__accept' htmlFor='personal-use-accept'>
      <input
        id='personal-use-accept'
        className='form-check-input'
        type='checkbox'
        checked={accepted}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span>
        این تعهد را خواندم و می‌پذیرم که فقط با حساب شخصی خودم وارد شوم و اطلاعات ورودم را در اختیار
        هیچ‌کس نگذارم.
      </span>
    </label>
    <TermsViewerButton className='account-entry__terms'>قوانین و مقررات</TermsViewerButton>
  </section>
)
